var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"side-menu-btn",on:{"click":_vm.onMenuItemClick}},[_c('fluent-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }